<template>
  <Dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    @close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="24">
          <el-form-item label="上级菜单" prop="parentId">
            <el-cascader
              v-model="form.parentId"
              :options="parentOptions"
              :props="parentCascaderProps"
              :disabled="parentDisabled"
              clearable
              filterable
              placeholder="请选择上级菜单"
              class="selectw"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="菜单类型" prop="menuType">
            <el-radio-group v-model="form.menuType">
              <el-radio label="M">目录</el-radio>
              <el-radio label="C">菜单</el-radio>
              <el-radio label="F">按钮</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="显示排序" prop="orderNum">
            <el-input-number
              v-model="form.orderNum"
              :min="0"
              controls-position="right"
              class="selectw"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="菜单名称" prop="menuName">
            <el-input
              v-model.trim="form.menuName"
              placeholder="请输入菜单名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.menuType !== 'F'">
          <el-form-item label="菜单图标" prop="icon">
            <el-input
              v-model.trim="form.icon"
              placeholder="如 course、system"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.menuType !== 'F'">
          <el-form-item label="路由地址" prop="path">
            <el-input
              v-model.trim="form.path"
              placeholder="如 /course"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.menuType === 'C'">
          <el-form-item label="组件路径" prop="component">
            <el-input
              v-model.trim="form.component"
              placeholder="如 views/Course/index"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.menuType !== 'M'">
          <el-form-item label="权限标识" prop="perms">
            <el-input
              v-model.trim="form.perms"
              placeholder="如 system:menu:list"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="显示状态">
            <el-radio-group v-model="form.visible">
              <el-radio label="0">显示</el-radio>
              <el-radio label="1">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="菜单状态">
            <el-radio-group v-model="form.status">
              <el-radio label="0">正常</el-radio>
              <el-radio label="1">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button plain round size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import {
  menuGet,
  menuAdd,
  menuUpdate,
  menuTreeSelect
} from "@/api/system/menu";

function createEmptyForm() {
  return {
    menuId: undefined,
    parentId: 0,
    menuName: "",
    orderNum: 0,
    path: "",
    component: "",
    menuType: "M",
    visible: "0",
    status: "0",
    perms: "",
    icon: "",
    routerName: "",
    isFrame: "1",
    isCache: "0",
    query: ""
  };
}

export default {
  name: "MenuForm",
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      parentDisabled: false,
      parentOptions: [],
      parentCascaderProps: {
        value: "id",
        label: "label",
        children: "children",
        checkStrictly: true,
        emitPath: false
      },
      editingMenuId: undefined,
      form: createEmptyForm(),
      rules: {
        parentId: [
          { required: true, message: "请选择上级菜单", trigger: "change" }
        ],
        menuName: [
          { required: true, message: "请输入菜单名称", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "请输入显示排序", trigger: "change" }
        ],
        menuType: [
          { required: true, message: "请选择菜单类型", trigger: "change" }
        ]
      }
    };
  },
  computed: {
    dialogTitle() {
      if (this.type === "edit") return "修改菜单";
      if (this.type === "addChild") return "新增子菜单";
      return "新增菜单";
    }
  },
  methods: {
    async loadParentOptions(excludeId) {
      try {
        const res = await menuTreeSelect();
        const tree = this.normalizeTree(res.data || [], excludeId);
        this.parentOptions = [{ id: 0, label: "主类目" }].concat(tree);
      } catch (e) {
        this.parentOptions = [{ id: 0, label: "主类目" }];
      }
    },
    /** 规范化树节点，编辑时排除自身及子节点，避免选为自己的上级 */
    normalizeTree(list, excludeId) {
      const result = [];
      (list || []).forEach(item => {
        if (excludeId != null && Number(item.id) === Number(excludeId)) {
          return;
        }
        const node = {
          id: item.id,
          label: item.label
        };
        if (item.children && item.children.length) {
          const children = this.normalizeTree(item.children, excludeId);
          if (children.length) {
            node.children = children;
          }
        }
        result.push(node);
      });
      return result;
    },
    async open(type, row = {}) {
      this.type = type;
      this.parentDisabled = type === "addChild";
      this.editingMenuId = type === "edit" ? row.menuId : undefined;
      await this.loadParentOptions(this.editingMenuId);
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });

      if (type === "edit") {
        try {
          const res = await menuGet(row.menuId);
          const data = res.data || {};
          this.form = Object.assign(createEmptyForm(), data, {
            parentId:
              data.parentId === undefined || data.parentId === null
                ? 0
                : data.parentId
          });
        } catch (e) {
          this.cancel();
        }
        return;
      }

      this.form = createEmptyForm();
      if (type === "addChild") {
        this.form.parentId = row.menuId;
        this.form.menuType = row.menuType === "M" ? "C" : "F";
      }
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        const payload = Object.assign({}, this.form, {
          parentId:
            this.form.parentId === undefined ||
            this.form.parentId === null ||
            this.form.parentId === ""
              ? 0
              : this.form.parentId
        });
        if (payload.menuId) {
          await menuUpdate(payload);
          this.$message.success("修改成功");
        } else {
          await menuAdd(payload);
          this.$message.success("新增成功");
        }
        this.cancel();
        this.$emit("success");
      } catch (e) {
        // axios 拦截器已提示
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = createEmptyForm();
      this.parentDisabled = false;
      this.editingMenuId = undefined;
    }
  }
};
</script>

<style scoped>
.selectw {
  width: 100%;
}
.selectw >>> .el-input,
.selectw >>> .el-cascader {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Menu/MenuForm.vue